/**
 * Upload an image to ImgBB and return the public URL.
 * Get your API key at https://api.imgbb.com/
 * Set REACT_APP_IMGBB_API_KEY in .env (and in Netlify/env for production).
 */

const IMGBB_UPLOAD_URL = 'https://api.imgbb.com/1/upload';

export interface ImgBBResponse {
  data: {
    url: string;
    display_url: string;
    delete_url?: string;
    id: string;
  };
}

export async function uploadImageToImgBB(base64DataUrl: string): Promise<string> {
  const apiKey = process.env.REACT_APP_IMGBB_API_KEY;
  if (!apiKey || apiKey.trim() === '') {
    throw new Error('ImgBB API key is not set. Add REACT_APP_IMGBB_API_KEY to your .env file. Get a key at https://api.imgbb.com/');
  }

  // ImgBB accepts base64 with or without data URL prefix; use raw base64 for consistency
  const base64 = base64DataUrl.includes(',') ? base64DataUrl.split(',')[1] : base64DataUrl;

  const form = new FormData();
  form.append('key', apiKey);
  form.append('image', base64);

  const res = await fetch(IMGBB_UPLOAD_URL, {
    method: 'POST',
    body: form,
  });

  const json = await res.json();

  if (!res.ok) {
    const msg = json?.error?.message || json?.message || res.statusText;
    throw new Error(`ImgBB upload failed: ${msg}`);
  }

  const url = json?.data?.url;
  if (!url) {
    throw new Error('ImgBB did not return an image URL.');
  }

  return url;
}
